import React from 'react';
import { OrderItemAddOn } from 'shared-client/types/commerce/add-ons';
import { OrderItem } from '../shopping-cart/types';
import { OrderDetailsItemImage } from './OrderDetailsItem';

/**
 * Order details add on item component props
 */
interface OrderDetailsAddOnItemProps {
	/**
	 * The minimum set of display data for the add-on order item
	 */
	addOnItem: OrderItemAddOn;
	/**
	 * The parent order item for the add-on order item
	 */
	addOnParentItem: OrderItem;
	/**
	 * The indexing key
	 */
	index?: number;
}

/**
 * Order details for add on item component.
 * Renders the given item details for the my account order details page for the addon order item.
 */
export default function OrderDetailsAddOnItemCustom(props: OrderDetailsAddOnItemProps) {
	const { addOnItem, index } = props;

	return (
		<>
			<td className="roc-manage-layout__table-col-img">
				{addOnItem.imageUrl ? (
					<OrderDetailsItemImage
						thumbnailUrl={addOnItem.imageUrl}
						altText={addOnItem.altText}
						productName={addOnItem.addOnData.name}
					/>
				) : null}
			</td>
			<td>
				<p className="roc-manage-layout__table-heading">
					<strong data-testid={`addon-item-name-${index}`}>{addOnItem.addOnData.name}</strong>
				</p>

				{addOnItem.addOnData.attributes && addOnItem.addOnData.attributes.length > 0 ? (
					<ul data-testid={`addon-item-attributes-${index}`}>
						{addOnItem.addOnData.attributes?.map((attribute, idx) => {
							const attrValue = attribute?.customData ?? attribute.values?.find((v) => v.selected)?.name;
							return (
								<>
									{attrValue ? (
										<li key={idx}>
											<strong>{attribute.name}</strong>: <span>{attrValue}</span>{' '}
										</li>
									) : null}
								</>
							);
						})}
					</ul>
				) : null}
			</td>
			<td></td>
			<td></td>
		</>
	);
}
